import { render, staticRenderFns } from "./TransactionTimeline.vue?vue&type=template&id=54ddbdd4"
import script from "./TransactionTimeline.vue?vue&type=script&lang=ts"
export * from "./TransactionTimeline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports